import { createContext } from 'react';
import type { AuthUser } from './auth-service';

export interface AuthContextType {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (token: string) => Promise<void>;
  logout: () => void;
  fetchUser: () => Promise<AuthUser | null>;
  devLogin: (token: string, mockUser: AuthUser) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
